import React from 'react';

import useTypewriter from '../../hooks/useTypewriter';
import MarkdownMessage from './MarkdownMessage';

// Simulates the reply being written out. Reporting completion lets the parent
// retire the flag, making the reveal a one-shot per reply.
const TypedMarkdownMessage = ({
  content,
  animate,
  messageIndex,
  onTyped,
}: {
  content: string;
  animate: boolean;
  messageIndex: number;
  onTyped: (index: number) => void;
}) => {
  const typedContent = useTypewriter(content, animate);
  const fullyTyped = typedContent === content;

  React.useEffect(() => {
    if (animate && fullyTyped) onTyped(messageIndex);
  }, [animate, fullyTyped, messageIndex, onTyped]);

  return (
    <MarkdownMessage content={typedContent} />
  );
};
export default TypedMarkdownMessage;
